

<table class = 'table bg-light'>

  <th scope="col">#</th>
  <th scope="col">Country Name</th>
  <th scope="col">Total Cases</th>
    <th scope="col">Deaths</th>
  <th scope="col">Recovered</th>
  <th scope="col">Active</th>
  <th scope="col">Critical</th>
  <th scope="col">Cases Per Million</th>


<tbody>
  <tr *ngFor = "let Data of data; let i = index">

    <!-- "'/profile/' + user.uid" -->
      <td>{{i+1}}</td>
      <td><a [routerLink] = "'/countries/' + Data.country">{{Data.country}}</a></td>
      <td>{{Data.cases}}</td>
      <td>{{Data.deaths}}</td>
      <td>{{Data.recovered}}</td>
      <td>{{Data.active}}</td>
      <td>{{Data.critical}}</td>
      <td>{{Data.casesPerOneMillion}}</td>


  </tr>
</tbody>
</table>

